import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { checkForAdmin } from "./helpers/requests.tsx";
import { useAuth } from "../firebase/auth.tsx";
import { useTranslation } from "react-i18next";

import "../App.css";

const PageMenu = ({
  userId,
  userRole,
  firstName,
  lastName,
  email,
  headquarterId,
  groupId,
  logout,
  fullScreenMode,
}) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isHeadquarterAdmin, setIsHeadquarterAdmin] = useState(false);
  const [isGroupAdmin, setIsGroupAdmin] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);

  const { changeLanguage } = useAuth();

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const languageImages = {
    en: "/images/flags/English.png",
    de: "/images/flags/German.png",
    cz: "/images/flags/Czech.png",
  };

  // Preload language images
  useEffect(() => {
    Object.values(languageImages).forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsLanguageMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!email || !userRole) {
      navigate("/login");
      return;
    }

    const fetchData = async () => {
      const result = await checkForAdmin(userId);

      if (result.admin) setIsAdmin(result.admin);
      else if (result.headquarterAdmin)
        setIsHeadquarterAdmin(result.headquarterAdmin);
      else if (result.groupAdmin) setIsGroupAdmin(result.groupAdmin);
    };

    fetchData();
  }, []);

  const handleStreamClick = () => {
    navigate(`/stream/${userId}`, { replace: true });
  };

  const handleLanguageClick = (newLanguage) => {
    toggleLanguageMenu();
    changeLanguage(newLanguage);
  };

  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen((prev) => !prev);
  };

  const handleQuestionClick = () => {
    let link;
    if (isHeadquarterAdmin) {
      if (i18n.language === "cz")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7D_NiSa4UCcziX-i8lypTnO";
      else if (i18n.language === "en")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7C0RH0j1qy86PZD7vsRvIwu";
      else if (i18n.language === "de")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7AAZtPzPo4M0xQkKw3VUu48";
    }
    else if (isGroupAdmin) {
      if (i18n.language === "cz")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7C6-W-ccQ8xEOEQvb68Dtgx";
      else if (i18n.language === "en")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7CdM_qXjbgfFNMuntikLzje";
      else if (i18n.language === "de")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7Db6qKeXJW55u9aUVd9ytXz";
    }
    else {
      if (i18n.language === "cz")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7BYic6WMClcO2vBN8EorXd_";
      else if (i18n.language === "en")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7BQnwkDjRDEK_9CGathn1Ri";
      else if (i18n.language === "de")
        link = "https://www.youtube.com/playlist?list=PLNmM6qyy6Z7DbMRr1JQxwXkzyiV2Cn2sB";
    }

    window.open(link, "_blank");
  };

  return (
    <div>
      {!fullScreenMode && (
        <div
          style={{
            backgroundColor: "#183a68",
            borderRadius: "10px",
            marginTop: "16px",
            padding: "12px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "fixed",
            top: "0",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: "11",
            width: "96%",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src="\images\Hlavni-logo-VR-CPR_white-1024x213.png"
              alt="Logo"
              style={{
                width: "8vh",
                minWidth: "50px",
                marginLeft: "10px",
              }}
            />
            <Link
              to="/main"
              style={{
                color: "white",
                marginLeft: "50px",
                textDecoration: "none",
              }}
            >
              {t("training_reports")}
            </Link>
            <a
              onClick={handleStreamClick}
              style={{
                color: "white",
                marginLeft: "50px",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              {t("stream")}
            </a>
            {isAdmin && (
              <>
                <span
                  style={{
                    width: "1px",
                    height: "20px",
                    backgroundColor: "white",
                    marginLeft: "45px",
                  }}
                ></span>
                <Link
                  to="/headquarterList"
                  style={{
                    color: "white",
                    marginLeft: "45px",
                    textDecoration: "none",
                  }}
                >
                  {t("headquarter_list")}
                </Link>
                <Link
                  to="/groups"
                  style={{
                    color: "white",
                    marginLeft: "45px",
                    textDecoration: "none",
                  }}
                >
                  {t("group_list")}
                </Link>
                <Link
                  to="/allUsers"
                  style={{
                    color: "white",
                    marginLeft: "45px",
                    textDecoration: "none",
                  }}
                >
                  {t("user_list")}
                </Link>
              </>
            )}
            {isGroupAdmin && (
              <>
                <div
                  style={{
                    width: "1px",
                    height: "20px",
                    backgroundColor: "white",
                    marginLeft: "45px",
                  }}
                ></div>
                <Link
                  to={`/userList/group/${groupId}`}
                  style={{
                    color: "white",
                    marginLeft: "45px",
                    textDecoration: "none",
                  }}
                >
                  {t("Group")}
                </Link>
              </>
            )}
            {isHeadquarterAdmin && (
              <>
                <div
                  style={{
                    width: "1px",
                    height: "20px",
                    backgroundColor: "white",
                    marginLeft: "45px",
                  }}
                ></div>
                <Link
                  to={`/groupList/headquarter/${headquarterId}`}
                  style={{
                    color: "white",
                    marginLeft: "45px",
                    textDecoration: "none",
                  }}
                >
                  {t("Headquarter")}
                </Link>
              </>
            )}
            {userRole !== "admin" && ["cz", "en", "de"].includes(i18n.language) && (
              <>
                <img
                  src="/images/question.png"
                  alt="Help"
                  title={t("How_to_use_this_site")}
                  style={{
                    width: "26px",
                    marginLeft: "40px",
                    cursor: "pointer",
                  }}
                  onClick={handleQuestionClick}
                />
              </>
            )}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {/* Documentation button */}
            <a
              href="https://vrcpr.macaly.app/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#ffffff",
                color: "#27538D",
                padding: "6px 14px",
                borderRadius: "20px",
                textDecoration: "none",
                fontSize: "0.9em",
                fontFamily: "VirtualLabQuickSandBold",
                marginRight: "25px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                whiteSpace: "nowrap",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#ebf2fa";
                e.currentTarget.style.transform = "scale(1.03)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#ffffff";
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <img
                src="/images/docs.png"
                alt="Documentation"
                style={{ width: "20px", height: "20px" }}
              />
              {t("documentation")}
            </a>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                marginRight: "10px",
                color: "white",
                lineHeight: "1",
              }}
            >
              <div
                style={{
                  textAlign: "right",
                  paddingBottom: "3px",
                }}
              >
                {firstName} {lastName}
              </div>
              <div
                style={{
                  textAlign: "right",
                  fontFamily: "VirtualLabQuickSandLight",
                }}
              >
                {email}
              </div>
            </div>
            <img
              src="/images/Icon_User.png"
              alt="Logo"
              style={{
                width: "8%",
                marginRight: "10px",
              }}
            />
            <div style={{ position: "relative" }} ref={dropdownRef}>
              <button
                onClick={toggleLanguageMenu}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <img
                  src={`/images/flags/${
                    i18n.language === "de"
                      ? "German.png"
                      : i18n.language === "cz"
                      ? "Czech.png"
                      : "English.png"
                  }`}
                  alt="Language"
                  style={{ width: "30px", height: "20px" }}
                />
              </button>
              {isLanguageMenuOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "30px",
                    marginLeft: "-4px",
                    background: "#cccccc",
                    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                    borderRadius: "5px",
                    zIndex: "20",
                  }}
                >
                  {Object.entries(languageImages).map(([lang, src]) => (
                    <div
                      key={lang}
                      onClick={() => handleLanguageClick(lang)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={src}
                        alt={lang}
                        style={{ width: "30px", height: "20px" }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button
              onClick={logout}
              style={{
                backgroundColor: "transparent",
                marginRight: "20px",
                border: "none",
                color: "white",
                cursor: "pointer",
              }}
            >
              {t("log_out")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageMenu;
